import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instruction-english',
  templateUrl: '../views/instructions.english.html',
  styleUrls: ['../views/staff.component.css','../../../css/instructions.component.css', '../../../css/paper-sets.component.css', '../../setting/setting.component.css']
})
export class InstructionEnglishComponent implements OnInit {

  constructor() { }

  ngOnInit() {

    
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/instructions/components/instruction-english.component.ts